import { render, staticRenderFns } from "./Screenshot.vue?vue&type=template&id=5c1a2ba0&"
import script from "./Screenshot.vue?vue&type=script&lang=js&"
export * from "./Screenshot.vue?vue&type=script&lang=js&"
import style0 from "./Screenshot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports